import React, { useEffect, useState } from 'react';
import API from '../api';
import '../styles/global.css';

export default function SearchPage() {
  const [q, setQ] = useState('');
  const [parties, setParties] = useState([]);
  const [txs, setTxs] = useState([]);

  // Fetch results whenever 'q' changes
  useEffect(() => {
    const fetchResults = async () => {
      if (!q) {
        setParties([]);
        setTxs([]);
        return;
      }

      try {
        const [{ data: ps }, { data: ts }] = await Promise.all([
          API.get('/parties', { params: { q } }),
          API.get('/transactions', { params: { q } }),
        ]);
        setParties(ps);
        setTxs(ts);
      } catch (e) {
        console.error('Search failed', e);
      }
    };

    // Add a small debounce so it doesn't call API on every keystroke
    const timeoutId = setTimeout(fetchResults, 300);
    return () => clearTimeout(timeoutId);
  }, [q]);

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)', fontFamily: "'Inter', sans-serif", padding: 0 }}>
      {/* Navbar */}
      <nav style={{ background: 'rgba(255,255,255,0.98)', borderBottom: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 2px 20px rgba(0,0,0,0.04)', padding: '20px 60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1a1a1a' }}>🔍 Search</div>
      </nav>

      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '40px 60px' }}>
        {/* Search Card */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid rgba(0,0,0,0.06)' }}>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
            <input
              style={{ flex: 1, padding: '12px 16px', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '0.95rem', fontFamily: 'inherit', outline: 'none', transition: 'all 0.2s ease' }}
              placeholder="Search parties, invoices, notes..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>

          {/* Parties Table */}
          <h4 style={{ marginBottom: 12, color: '#1a202c' }}>Parties</h4>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
                  <th style={{ textAlign: 'left', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Name</th>
                  <th style={{ textAlign: 'left', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Phone</th>
                  <th style={{ textAlign: 'right', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Balance</th>
                </tr>
              </thead>
              <tbody>
                {parties.map((p) => (
                  <tr key={p._id} style={{ borderBottom: '1px solid #e2e8f0', transition: 'background 0.2s' }}
                      onMouseOver={(e) => (e.currentTarget.style.background = '#f7fafc')}
                      onMouseOut={(e) => (e.currentTarget.style.background = 'transparent')}>
                    <td style={{ padding: '12px' }}>{p.name}</td>
                    <td style={{ padding: '12px' }}>{p.phone || '-'}</td>
                    <td style={{ padding: '12px', textAlign: 'right' }}>{p.balance || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Transactions Table */}
          <h4 style={{ marginTop: 24, marginBottom: 12, color: '#1a202c' }}>Transactions</h4>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
                  <th style={{ textAlign: 'left', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Date</th>
                  <th style={{ textAlign: 'left', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Party</th>
                  <th style={{ textAlign: 'left', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Invoice</th>
                  <th style={{ textAlign: 'right', padding: '12px', fontWeight: 600, color: '#4a5568' }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {txs.map((t) => (
                  <tr key={t._id} style={{ borderBottom: '1px solid #e2e8f0', transition: 'background 0.2s' }}
                      onMouseOver={(e) => (e.currentTarget.style.background = '#f7fafc')}
                      onMouseOut={(e) => (e.currentTarget.style.background = 'transparent')}>
                    <td style={{ padding: '12px' }}>{new Date(t.date).toLocaleDateString()}</td>
                    <td style={{ padding: '12px' }}>{t.party?.name || '-'}</td>
                    <td style={{ padding: '12px' }}>{t.invoiceNumber || '-'}</td>
                    <td style={{ padding: '12px', textAlign: 'right' }}>{t.amont}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
